// extracted by mini-css-extract-plugin
export default {"container":"ModuleFeed_container__-I3sq","loading":"ModuleFeed_loading__rAb8m"};